import { ChangeDetectionStrategy, Component, Injectable } from '@angular/core';
import { CameraPermissionBlockService } from 'services/camera-permission-block.service';
import { ScannerName } from 'services/camera-permission-help';

// Stand-in for CameraPermissionBlockService, used only on the Test UI Components page (#6020).
// cs-scanner-permission-denied reports every showing of itself to the real service, which sends
// the camera_permission_blocked analytics event and, on the third showing in a session, files a
// Sentry problem. A test page must not count as a user blocked by the camera, so this stand-in
// accepts the report and records nothing.
@Injectable()
export class DemoCameraPermissionBlockService {
  // records nothing: the test page is not a real blocked camera
  recordBlockedCardShown(_scanner: ScannerName): void {}
}

// The camera-blocked panel, drawn with its reporting routed to the stand-in above.
@Component({
  selector: 'cs-test-permission-denied-demo',
  template: `<cs-scanner-permission-denied [scanner]="ScannerName.Barcode"></cs-scanner-permission-denied>`,
  providers: [
    DemoCameraPermissionBlockService,
    { provide: CameraPermissionBlockService, useExisting: DemoCameraPermissionBlockService },
  ],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestPermissionDeniedDemoComponent {
  readonly ScannerName = ScannerName;
}
